import dayjs from "@/helpers/dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import mixinOrder from "./mixinOrder";
import PQueue from "p-queue/dist";

const queue = new PQueue({ concurrency: 1 });

const CONFIG = {
  FEE_LIST: [
    "totalFee",
    "timeChargeFee",
    "weatherChargeFee",
    "specialDayChargeFee",
    "baseFee",
    "weightFee",
    "distanceFee",
    "waypointsFee",
    "vat",
    "notifiedPrice",
    "totalExtraFee",
    "fixedFee",
    "totalOrderFee",
    "totalDeliveryFee",
    "expressDeliveryFee",
    "extraFixedFee",
    "displayNormalTotalFee",
    "displayExpressTotalFee",
  ],
  FREIGHT_FEE_LIST: [
    "freightDistanceFee", //거리별 기본요금
    "freightOptionsFee", //옵션요금
    "waypointsFee", //경유요금
    "expressDeliveryFee", //급송요금
    "fixedFee", //백단위절사
    "timeChargeFee", //시간할증
    "weatherChargeFee", //기상할승
    "specialDayChargeFee", //특수일할증
    "extraFixedFee", //할증요금 백단위 절서
    "vat", // 부가세
    "totalFee",
    "notifiedPrice",
    "totalExtraFee",
    "totalOrderFee",
    "totalDeliveryFee",
    "displayNormalTotalFee",
    "displayExpressTotalFee",
  ],
  ALL_FEE_LIST: [
    "timeChargeFee", // 시간할증 요금
    "weatherChargeFee", // 기상할증 요금
    "specialDayChargeFee", // 특수일 할증
    "baseFee", //기본요금
    "weightFee", // 무게요금
    "distanceFee", // 거리요금
    "freightDistanceFee", //화물 거리별 요금
    "waypointsFee", // 경유지 요금
    "notifiedPrice", //총요금(부가세 불포함) 현재 사용 안함.
    "vat", //부가세
    "totalExtraFee", //총 할증 요금
    "deliveryfixedFee", //배송요금 백단위절사
    "additionalfixedFee", //할증요금 백단위절사
    "totalOrderFee", //최종요금
    "totalDeliveryFee", //총 배송요금
    "fixedFee", //할증운임 백단위 절사
    "expressDeliveryFee", //급송요금
    "extraFixedFee", // 할증운임 백단위절사
    "displayNormalTotalFee", //노출용 일반 최종요금
    "displayExpressTotalFee", //노출용 급송 최종 요금
    "freightOptionsFee", //화물 총 옵션 요금
    "totalFee",
  ],
};

export default {
  mixins: [mixinOrder],
  data() {
    return {
      step: 1,
      isLoading: false,
      pinInvalid: [
        {
          name: false,
          phoneNumber: false,
          coords: false,
        },
        {
          name: false,
          phoneNumber: false,
          coords: false,
        },
      ],
      inValidatePinIdx: [],
      itemInvalid: false,
      timeInvalid: false,
      deliveryItemInvalid: false,
      orderAvailable: false,
    };
  },
  computed: {
    getLoadingStatus() {
      return this.isLoading;
    },

    getStep() {
      return this.step;
    },

    getPinvalidate() {
      return this.inValidatePinIdx;
    },

    getItemInvalid() {
      return this.itemInvalid;
    },

    getTimeInvalid() {
      return this.timeInvalid;
    },
  },
  methods: {
    /**
     *
     * 출발지, 도착지 같은 주소인지 확인
     */
    checkCoords() {
      if (this.getPins.length === 2) {
        if (this.getPins[0].coords && this.getPins[1].coords) {
          const isSameLat =
            this.getPins[0].coords[0] === this.getPins[1].coords[0];
          const isSameLng =
            this.getPins[0].coords[1] === this.getPins[1].coords[1];

          return isSameLat && isSameLng;
        }
      }
      return false;
    },

    /**
     *
     * 요금계산 로직
     */
    async calculate() {
      const pushQueue = async () => {
        let calculateResult;
        const categoryCode = this.getDeliveryOptions.vehicleCategory;
        if (this.getDeliveryOptions.isReserved === null) return;
        if (!this._checkPinValidateBeforeCalculate()) return;

        if (this.getDeliveryOptions.vehicleItemCode === 1) {
          if (this.getDeliveryOptions.weight <= 0 || "") return;
        }
        try {
          this.isLoading = true;
          const payload = this._getPayloadByCategory(categoryCode);
          try {
            calculateResult =
              categoryCode !== 8
                ? await this.$store.dispatch("calculator/calculate", payload)
                : await this.$store.dispatch(
                    "calculator/calculateFreight",
                    payload
                  );
            if (!calculateResult.success) {
              this.isLoading = false;
              this._resetCalculateData();
              return alert("서버에러가 발생하였습니다.");
            }
          } catch (e) {
            console.error(e);
            this.isLoading = false;
            this._resetCalculateData();
            return alert("서버에러가 발생하였습니다");
          }

          //급송 선택 전엔 display용 필드만 업데이트
          if (this.getDeliveryOptions.isExpressDelivery === null) {
            this._updateOnlyDisplayFee(calculateResult);
            this.isLoading = false;
            return;
          }

          this._updateDeliveryOptionsAfterCalc(calculateResult);
          this._updateFeeAfterCalc(calculateResult, categoryCode);

          this.isLoading = false;
        } catch (error) {
          console.error(error);

          return alert("서버에러가 발생하였습니다(2)");
        }
      };

      try {
        queue.clear();
        await queue.add(pushQueue); // queue 에 추가
      } catch (e) {
        alert("운임계산 중 문제가 발생했습니다.");
      }
    },

    /**
     *
     * @param {number} categoryCode
     * categoryCode 에 따른 calculate payload 데이터 가공
     */
    _getPayloadByCategory(categoryCode) {
      const waypoints = [];
      let pickupTime;
      let payload = {};
      if (this.getPins.length > 2) {
        // 경유지 있을 경우
        for (let i = 1; i < this.getPins.length - 1; i++) {
          waypoints.push({
            Lat: this.getPins[i].coords[0],
            Lng: this.getPins[i].coords[1],
          });
        }
      }
      if (
        this.getPins[0].pickupDate &&
        this.getPins[0].pickupHour &&
        this.getPins[0].pickupMinute
      ) {
        pickupTime = dayjs(
          `${this.getPins[0].pickupDate} ${this.getPins[0].pickupHour}:${this.getPins[0].pickupMinute}:00`
        );
      } else pickupTime = dayjs();

      if (categoryCode === 8) {
        payload = {
          depLat: parseFloat(this.getPins[0].coords[0]),
          depLng: parseFloat(this.getPins[0].coords[1]),
          destLat: parseFloat(this.getPins[this.getPins.length - 1].coords[0]),
          destLng: parseFloat(this.getPins[this.getPins.length - 1].coords[1]),
          waypoints,
          pickupTime: pickupTime,
          vehicleCategory: this.getDeliveryOptions.vehicleCategory,
          vehicleType: this.getDeliveryOptions.vehicleType,
          vehicleOption: this.getDeliveryOptions.vehicleOption,
          loadingPosition: this.getDeliveryOptions.loadingPosition,
          loadingMethod: this.getDeliveryOptions.loadingMethod,
          unloadingPosition: this.getDeliveryOptions.unloadingPosition,
          unloadingMethod: this.getDeliveryOptions.unloadingMethod,
          isReserved: this.getDeliveryOptions.isReserved,
          isExpressDelivery:
            this.getDeliveryOptions.isExpressDelivery !== null
              ? this.getDeliveryOptions.isExpressDelivery
              : false,
        };
      } else {
        payload = {
          depLat: parseFloat(this.getPins[0].coords[0]),
          depLng: parseFloat(this.getPins[0].coords[1]),
          destLat: parseFloat(this.getPins[this.getPins.length - 1].coords[0]),
          destLng: parseFloat(this.getPins[this.getPins.length - 1].coords[1]),
          weight: this.getDeliveryOptions.weight,
          waypoints,
          pickupTime: pickupTime,
          isReserved: this.getDeliveryOptions.isReserved,
          isExpressDelivery:
            this.getDeliveryOptions.isExpressDelivery !== null
              ? this.getDeliveryOptions.isExpressDelivery
              : false,
        };
      }

      return payload;
    },

    /**
     *
     * 급송/예약 선택 전 금액 표시
     */
    _updateOnlyDisplayFee(result) {
      const payload = {
        express: result.displayExpressTotalFee,
        normal: result.displayNormalTotalFee,
      };

      const estimatePayload = {
        estimatedMinutes: result.estimatedMinutes,
        expressEstimatedMinutes: result.expressEstimatedMinutes,
        reserveEstimatedMinutes: result.reserveEstimatedMinutes,
        reserveExpressEstimatedMinutes: result.reserveExpressEstimatedMinutes,
      };
      this.updateDisplayFees(payload);
      this.updateEstimatedMinutes(estimatePayload);
    },

    /**
     *
     * 주소지카드 입력값 유효성검사
     */
    checkPinValidate() {
      this.inValidatePinIdx = [];
      let hasInvalid = false;
      for (let i = 0; i < this.getPins.length; i++) {
        const pin = this.getPins[i];

        const invalid = this.pinInvalid[i];
        let idx;

        for (const key in invalid) {
          if (pin.hasOwnProperty(key)) {
            const value = pin[key];
            if (!value) {
              invalid[key] = true;
              hasInvalid = true;
              idx = i;
            }
          }
        }
        if (idx !== undefined) {
          this.inValidatePinIdx.push(idx);
        }
      }
      if (!hasInvalid && this.step === 1) {
        this.step = 2;
      }
      return !hasInvalid;
    },

    /**
     *
     * 물품정보 유효성검사
     */
    checkItemvalidate() {
      const hasOnItem = Object.values(this.getDeliveryOptions.item).some(
        (subItem) => subItem.on === true
      );

      const hasContent =
        this.getDeliveryOptions.item.etc.on &&
        this.getDeliveryOptions.item.etc.content !== null;
      if (
        hasOnItem &&
        (this.getDeliveryOptions.item.etc.on ? hasContent : true)
      ) {
        this.deliveryItemInvalid = false;
      } else {
        this.deliveryItemInvalid = true;
      }
      return (
        hasOnItem && (this.getDeliveryOptions.item.etc.on ? hasContent : true)
      );
    },

    checkItem() {
      // on이 true인 항목이 있는지 확인
      const hasOnItem = this.checkItemvalidate();

      // weight가 3 이상인지 확인
      const weightCondition = this.getDeliveryOptions.weight > 0;
      !hasOnItem || !weightCondition
        ? (this.itemInvalid = true)
        : (this.itemInvalid = false);
      // 조건을 만족하는지 확인하고 결과 반환
      return !this.itemInvalid;
    },
    checkFreightOption() {
      return (
        this.getDeliveryOptions.loadingPosition !== null &&
        this.getDeliveryOptions.unloadingPosition !== null &&
        this.getDeliveryOptions.loadingMethod !== null &&
        this.getDeliveryOptions.unloadingMethod !== null
      );
    },

    _checkDeliveryOptions() {
      if (this.getDeliveryOptions.vehicleCategory === null || !this.checkItem())
        return false;
      return true;
    },

    checkValidate() {
      if (!this.checkPinValidate() || !this._checkDeliveryOptions())
        return false;
      return true;
    },

    /**
     * 운임계산 후 응답 업데이트
     */
    _updateDeliveryOptionsAfterCalc(result) {
      const payload = {
        calcUuid: result.calcUuid ?? "",
        totalDistance: parseInt(result.distance, 10),
        estimatedMinutes: result.estimatedMinutes,
        expressEstimatedMinutes: result.expressEstimatedMinutes,
        reserveEstimatedMinutes: result.reserveEstimatedMinutes,
        reserveExpressEstimatedMinutes: result.reserveExpressEstimatedMinutes,
      };

      this.$store.commit("form/updateDeliveryOptionsAfterCalc", payload);
    },

    /**
     * 운임계산 실패시 0 으로 리셋
     */
    _resetCalculateData() {
      let deliveryOptions = _.cloneDeep(this.getDeliveryOptions);
      for (const value of CONFIG.ALL_FEE_LIST) {
        deliveryOptions[value] = 0;
      }

      const payload = {
        calcUuid: "",
        totalDistance: 0,
        estimatedMinutes: null,
        expressEstimatedMinutes: null,
        reserveEstimatedMinutes: null,
        reserveExpressEstimatedMinutes: null,
      };

      this.$store.commit("form/updateFeeAfterCalc", deliveryOptions);
      this.$store.commit("form/updateDeliveryOptionsAfterCalc", payload);
    },

    /**
     *
     * 운임계산 api 응답으로 요금 정보 업데이트
     */
    _updateFeeAfterCalc(result, code) {
      let deliveryOptions = _.cloneDeep(this.getDeliveryOptions);
      for (const value of code !== 8
        ? CONFIG.FEE_LIST
        : CONFIG.FREIGHT_FEE_LIST) {
        deliveryOptions[value] = parseInt(result[value], 10);
        if (isNaN(deliveryOptions[value])) {
          return alert(
            "요금조회에 실패했습니다. 다시 한번 시도해주세요. 계속해서 문제가 발생할 경우, 1544-4805로 문의해 주세요."
          );
        }
      }

      this.$store.commit("form/updateFeeAfterCalc", deliveryOptions);
    },

    /**
     *
     * 픽업시간 유효성검사
     */
    checkPickupTime() {
      dayjs.extend(isSameOrBefore);
      if (this.getDeliveryOptions.isReserved === false) return true;
      const pickupTime = dayjs(
        `${this.getPins[0].pickupDate} ${this.getPins[0].pickupHour}:${this.getPins[0].pickupMinute}:00`
      );
      const nowAdd60 = dayjs().add(60, "m");
      if (pickupTime.isSameOrBefore(nowAdd60, "m")) {
        this.timeInvalid = true;
        return false;
      } else {
        this.timeInvalid = false;
      }
      return true;
    },

    /**
     *
     * 운임계산 전 주소지카드 유효성 검증
     */
    _checkPinValidateBeforeCalculate() {
      for (let i = 0; i < this.getPins.length; i++) {
        if (!this.getPins[i].coords) return false;
        if (!this.getPins[i].coords[0] || !this.getPins[i].coords[1])
          return false;
      }
      return true;
    },

    /**
     *
     * @param {number} idx
     * 주소지 핀 추가
     */
    addPin(idx) {
      if (this.getPins.length === 15) return;
      let addedPins = this.getPins;
      addedPins.splice(idx + 1, 0, {
        name: "",
        phoneNumber: "",
        dongName: "",
        coords: null,
        jibunAddress: "",
        roadAddress: "",
        pickupDate: this.getPins[this.getPins.length - 1].pickupDate,
        pickupHour: this.getPins[this.getPins.length - 1].pickupHour,
        pickupMinute: this.getPins[this.getPins.length - 1].pickupMinute,
        detailAddress: "",
        addToBookmark: false,
        pinMemo: "",
      });

      this.pinInvalid.splice(idx + 1, 0, {
        name: false,
        phoneNumber: false,
        coords: false,
      });

      this.$store.commit("form/updatePins", addedPins);
    },

    /**
     *
     * @param {number} idx
     * 주소지 핀 삭제
     */
    deletePin(idx) {
      let deletedPins = this.getPins;
      deletedPins.splice(idx, 1);
      this.pinInvalid.splice(idx, 1);
      this.$store.commit("form/updatePins", deletedPins);
    },

    /**
     *
     * @param {number} idx
     * 주소지 순서 변경
     */
    swapPin(idx) {
      if (this.getPins.length === 1) return this.getPins;
      const pinsTime = {
        pickupDate: this.getPins[0].pickupDate,
        pickupHour: this.getPins[0].pickupHour,
        pickupMinute: this.getPins[0].pickupMinute,
      };

      let pins = this.getPins;

      pins.splice(idx + 1, 1, pins.splice(idx, 1, pins[idx + 1])[0]);
      this.pinInvalid.splice(
        idx + 1,
        1,
        this.pinInvalid.splice(idx, 1, this.pinInvalid[idx + 1])[0]
      );

      if (idx === 0) {
        pins[0].pickupDate = pinsTime.pickupDate;
        pins[0].pickupMinute = pinsTime.pickupMinute;
        pins[0].pickupHour = pinsTime.pickupHour;
      }
      this.$store.commit("form/updatePins", pins);
    },

    /**
     *
     * @param {number} step
     *
     */
    handleStep(step) {
      if (this.step < step) {
        this.step = step;
      }
    },

    resetStep() {
      this.step = 1;
    },
  },
};
